import { memo } from 'react';

const Skeleton = memo(() => (
  <div className="animate-pulse flex flex-col mx-auto xl:flex-row items-center justify-center w-full text-white py-6 gap-y-1 xl:gap-y-0 text-base gap-x-6 md:w-[548px] xl:w-full">
    <div className="hidden xl:flex rounded-full bg-slate-200 h-[280px] flex-wrap items-center justify-center py-[78px] px-[27px] w-[88px]" />
    <div className="relative z-10 w-full xl:w-[486px] xl:min-w-[486px] max-w-[358px] md:max-w-full h-auto lg:h-[108px] xl:h-[280px] rounded-2x bg-slate-200" />
    <div className="overflow-hidden relative z-10 text-wrap w-full xl:w-[486px] xl:min-w-[486px] max-w-[358px] md:max-w-full h-auto lg:h-[108px] xl:h-[280px] rounded-2xl bg-slate-200 p-4 xl:p-6 flex xl:items-start xl:justify-center flex-row xl:flex-col space-y-1" />
    <div className="hidden xl:flex rounded-full bg-slate-200 h-[280px] p-[62px]" />
  </div>
));

Skeleton.displayName = 'Skeleton';
export default Skeleton;
